
import axios from '../config/axios';

export const url = '/api/blogs'


export const customgetblogs_6945b493e307249250097b00 = ({
  categorias,

}) => new Promise((resolve, reject) => {
  if (true) {
    axios.get(`${url}/custom/getblogs`, {
      params: {
        categorias,

      },
      
    }).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});


export const customgetoneblogdcb98_6945b60de307249250097c03 = ({
  idblog,

}) => new Promise((resolve, reject) => {
  if (true) {
    axios.get(`${url}/custom/getoneblog`, {
      params: {
        idblog,

      },
      
    }).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});



